import { render, staticRenderFns } from "./BecaNivel.vue?vue&type=template&id=15b71232&scoped=true"
import script from "./BecaNivel.vue?vue&type=script&lang=js"
export * from "./BecaNivel.vue?vue&type=script&lang=js"
import style0 from "./BecaNivel.vue?vue&type=style&index=0&id=15b71232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b71232",
  null
  
)

export default component.exports